import { Link } from "react-router-dom";
import { Menu, Dropdown, Avatar, message } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { useGetCurrentUserQuery, useLogoutMutation } from "../../features/identity/identityApi";
import { useCallback } from "react";
import { useAppDispatch } from "../../app/hooks";
import { resetAllApiStates } from "../../app/actions";

export const AccountMenu = () => {
  const dispatch = useAppDispatch();
  const { data: currentUser, isFetching } = useGetCurrentUserQuery();
  const [logout] = useLogoutMutation();

  const logoutUser = useCallback(async () => {
    try {
      message.loading({ content: "در حال خروج", key: "logoutUser", duration: 0 });
      await logout().unwrap();
      dispatch(resetAllApiStates());
      message.success({
        content: "خروج با موفقیت انجام شد",
        key: "logoutUser",
        duration: 5,
      });
    } catch {
      message.error({
        content: "عملیات خروج با خطا مواجه شد",
        key: "logoutUser",
        duration: 5,
      });
    }
  }, [logout]);

  const menu = (
    <Menu style={{ minWidth: "120px" }}>
      <Menu.Item key="0" icon={<UserOutlined />}>
        {currentUser?.userName}
      </Menu.Item>
      <Menu.Item key="1" icon={<LogoutOutlined />} onClick={logoutUser}>
        خروج
      </Menu.Item>
    </Menu>
  );

  if (isFetching) {
    return null;
  }

  if (!currentUser) {
    return <Link to="/login">ورود</Link>;
  }

  return (
    <Dropdown overlay={menu}>
      <Link to="#" className="ant-dropdown-link block">
        <Avatar className="bg-indigo-500" icon={<UserOutlined />} />
      </Link>
    </Dropdown>
  );
};
